import * as React from "react";
import { Button as MuiButton } from "@mui/material";
import { classNames } from "utils";
import { Link } from "react-router-dom";
import { SimpleIcon } from "./Icon";

export default function Button({
  label,
  type,
  handleClick,
  disabled,
  otherClass,
  gradient,
  fullWidth,
  link,
  color = "primary",
  variant = "contained",
  size,
  Icon,
  labelIcon,
  state,
  isSubmitting,
}) {
  return (
    <MuiButton
      color={color}
      variant={variant}
      {...(link && { component: Link, to: link, state })}
      {...(handleClick && { onClick: handleClick })}
      // {...(disabled && { disabled })}
      {...(type && { type })}
      {...(size && { size })}
      disabled={disabled || isSubmitting}
      classes={{
        disabled: gradient ? "!text-white/50" : "",
      }}
      className={classNames(
        gradient
          ? "bg-gradient-to-r from-button_gradient_from to-button_gradient_to !text-white !shadow-md"
          : variant === "contained"
          ? "!shadow"
          : "",
        fullWidth ? "w-full" : "",
        "h-[36px] !text-sm !font-bold !capitalize hover:!shadow-button-alt",
        label,
        otherClass
      )}
      {...(labelIcon && {
        startIcon: (
          <SimpleIcon
            icon={labelIcon}
            otherClass="!text-[20px] mr-1"
            frontColor={variant === "outlined" ? "text-primary" : "text-white"}
          />
        ),
      })}
    >
      {!isSubmitting ? (
        <>
          {Icon ? (
            <Icon className="iconShadow" />
          ) : (
            <div className="whitespace-nowrap">{label}</div>
          )}
        </>
      ) : (
        <div>Loading..</div>
      )}
    </MuiButton>
  );
}
